import { PDFModal } from './pdf.modal';
import { SideModal } from '@design-system/components/modal/sideModal';
import { extrasVM } from '../Extras.page';
import { PDFForm } from './pdf.form';

export const PDFView = () => {
  const vm = extrasVM.useValue().pdfVM;
  return (
    <>
      <PDFModal
        isOpen={vm.mode === 'create'}
        content={vm.content}
        progress={vm.uploadProgress}
        onChange={(file) => vm.dispatch('Create', file)}
        onClose={() => vm.dispatch('Cancel')}
      />

      <SideModal
        isOpen={vm.mode === 'edit' || vm.mode === 'reupload'}
        onClose={() => vm.dispatch('Cancel')}
        noSpacing
      >
        <div style={{ padding: '24px 45px' }}>
          <PDFForm />
        </div>
      </SideModal>
      <PDFModal
        isOpen={vm.mode === 'reupload'}
        content={vm.content}
        progress={vm.uploadProgress}
        onChange={(file) => vm.dispatch('Reupload', file)}
        onClose={() => vm.dispatch('Cancel')}
      />
    </>
  );
};
